<template>
  <div
    class="main-list">
    <div class="header-list">
      <el-row>
        <el-col>
          <el-input
            v-debounce:1s="debounceChange"
            class="input-round"
            placeholder="Escribe tu busqueda"
            suffix-icon="icon-search"/>
        </el-col>
      </el-row>
    </div>
    <div
      v-if="goalsItems !== 0"
      class="content-list-item">
      <el-row>
        <el-col>
          <div class="title">
            <div class="item-title">
              <h1>Nombre</h1>
            </div>
            <div class="item-title">
              <h1>Objetivo</h1>
            </div>
          </div>
          <div
            v-for="(goalItem, index) in goalsList"
            :key="goalItem.id"
            :style="{animationDelay:(index * 50) + 'ms'}"
            :class="{active: goalItem.isActive === true}"
            class="item-client">
            <div
              class="content"
              @click="currentItem(goalItem)">
              <div class="item-title">
                <span>{{ goalsItemsName(goalItem) }}</span>
                <span v-if="goalsItemsType === 'branch'">{{ goalItem.dealerName }}</span>
              </div>
              <div class="item-title">{{ totalSales(goalItem.id) }}</div>
            </div>

            <div
              v-if="!hideActions"
              class="actions">
              <el-dropdown
                trigger="click"
                @command="handleCommand(goalItem)">
                <span class="el-dropdown-link">
                  <i class="icon-more-vertical"/>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="edit">
                    <div>
                      Editar <i class="icon-edit"/>
                    </div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div
            v-if="isLoading"
            style="display: flex; flex-align: center; justify-content: center;">
            <i
              class="el-icon-loading"
              style="color: #000; font-size: 20px;"/>
          </div>
        </el-col>
      </el-row>
      <div v-if="goalsItems === 0">
        <not-found @addElement="createNewClient"/>
      </div>
    </div>
  </div>
</template>
<script>
import ListItem from '@/components/_shared/list-item'
import NotFound from '@/components/_shared/not-found'

export default {
  name: 'GoalsDealerList',
  components: {
    ListItem,
    NotFound
  },
  props: {
    goalsItemsType: {
      type: String,
      default: 'dealer' // dealer, branch, seller
    },
    goalsItems: {
      type: Array,
      default: () => {
        return []
      }
    },
    goals: {
      type: Array,
      default: () => {
        return []
      }
    },
    hideActions: {
      type: Boolean,
      default: false
    },
    focusFirst: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      goalsList: [],
      filtersFor: [
        {
          name: 'Por Compañia',
          value: 'company'
        },
        {
          name: 'Por Nombre',
          value: 'firstName'
        }
      ],
      filtersValue: ''
    }
  },
  watch: {
    '$route': {
      handler (to, from) {
        let _goalsItems
        if (to.params.id) {
          _goalsItems = this.goalsItems.map(item => {
            item.isActive = false
            if (item.id === to.params.id) {
              item.isActive = true
            }
            return item
          })
        } else {
          _goalsItems = this.goalsItems
          if (this.focusFirst) {
            if (_goalsItems.length) { _goalsItems[0].isActive = true }
          }
        }
        this.goalsList = _goalsItems
      },
      immediate: true
    }
  },
  methods: {
    createNewClient () {
      this.$store.dispatch('app/toggleClientPanel')
    },
    handleCommand (obj) {
      this.$emit('onEdit', obj)
    },
    currentItem (val) {
      this.$emit('clickOnItem', val)
    },
    goalsItemsName (item) {
      switch (this.goalsItemsType) {
        case 'dealer':
          return item.name
        case 'branch':
          return item.city
        case 'seller':
          return `${item.firstName} ${item.lastName}`
        case 'territorial':
          return `${item.firstName} ${item.lastName}`
      }
    },
    totalSales (id) {
      let total = 0
      switch (this.goalsItemsType) {
        case 'dealer':
          for (let goal of this.goals) {
            if (goal.dealerId === id) {
              total = total + parseInt(goal.sales)
            }
          }
          return total
        case 'branch':
          for (let goal of this.goals) {
            if (goal.branchId === id) {
              total = total + parseInt(goal.sales)
            }
          }
          return total
        case 'seller':
          for (let goal of this.goals) {
            if (goal.userId === id) {
              total = total + parseInt(goal.sales)
            }
          }
          return total
        case 'territorial':
          for (let goal of this.goals) {
            if (goal.territorialId === id) {
              total = total + parseInt(goal.sales)
            }
          }
          return total
      }
    },
    debounceChange (value) {
      this.$router.push({...this.$route, query: {...this.$route.query, search: value}})
    }
  }
}
</script>

<style lang="scss" scoped>
  .main-list{
    height: 100%;
    .content-list-item{
      .title{
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: space-between;
        align-content: center;
        align-items: stretch;
        padding: 15px 25px 15px 10px;
        .item-title{
          flex: 0 1 auto;
          align-self: center;
          padding: 0 5px;          h1 {
            @include font-lato(13px, bold);
            color: #9D9D9D;
            margin: 0;
          }
        }
      }
      .item-client{
        padding-left: 10px;
        height: 45px;
        margin: 10px 0;
        transition: .3s;
        position: relative;
        display: flex;
        align-items: center;
        padding: 5px;
        &:hover{
          box-shadow: 0 0 10px #cccccc;
          cursor: pointer;
        }
        .content{
          height: 100%;
          width: 90%;
          display: flex;
          align-items: center;
          flex-direction: row;
          flex-wrap: nowrap;
          justify-content: space-between;
          align-content: center;
          align-items: center;
          .item-title{
            padding: 0 5px;
            margin: 0;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            span {
              display: block;
            }
            span:nth-child(1) {
              color: #3E3E3E;
              @include font-primary(13px, regular);
              margin-bottom: 3px;
            }
            span:nth-child(2) {
              color: #B5AFAF;
              @include font-primary(10px, regular);
            }
          }
        }
        .actions{
          height: 100%;
          width: 10%;
          display: flex;
          align-items: center;
          justify-content: center;
          i{
            font-size:22px;
          }
        }
        &.active{
          box-shadow: 0 0 10px #cccccc;
          .content{
            border-left: 4px solid $primary;
          }
        }
      }

    }
  }

</style>



// WEBPACK FOOTER //
// src/modules/goals/goals-dealer-list.vue